module.exports = __webpack_public_path__ + "img/match--type2_img8.490e7409.png";